import type { HttpStatusCode } from './types';

export type FieldError = {
  path: (string | number)[];
  message: string;
};

export class HttpError<TDetails = unknown> extends Error {
  readonly status: HttpStatusCode;
  readonly code: string;
  readonly details?: TDetails;
  readonly kind?: string;
  readonly fieldErrors?: FieldError[];

  constructor(
    status: HttpStatusCode,
    code: string,
    message?: string,
    options?: {
      details?: TDetails;
      kind?: string;
      fieldErrors?: FieldError[];
    },
  ) {
    super(message ?? code);

    this.name = new.target.name;
    this.status = status;
    this.code = code;
    this.details = options?.details;
    this.kind = options?.kind;
    this.fieldErrors = options?.fieldErrors;

    Object.setPrototypeOf(this, new.target.prototype);
  }
}
